"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubMenuItem = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.SubMenuItem = styled_components_1.default.li `
  position: relative;

  padding: ${props => props.withIcon ? "2.5px 25px 2.5px 2.5px" : "2.5px 25px"};
`;
//# sourceMappingURL=sub-menu-item.js.map